import errorsValidation from '@errors/validation';
import z from 'zod';

export const formSchema = z.object({
  weight: z.string().min(1, {
    message: errorsValidation.required,
  }),
  NaCl: z.string().min(1, {
    message: errorsValidation.required,
  }),
  KCl: z.string().min(1, {
    message: errorsValidation.required,
  }),
  mEq: z.string().min(1, {
    message: errorsValidation.required,
  }),
});
